import type { GuidedEditPayload } from "src/Manager/EventDetail/Nav/Marketing/ManagedCampaigns/components/CreateCampaignModal";
import type { BudgetData } from "src/Manager/EventDetail/Nav/Marketing/ManagedCampaigns/components/BudgetSelector";
import { wireGuidedEditBudgetFromFormDollars } from "src/Manager/EventDetail/Nav/Marketing/ManagedCampaigns/utils/wireGuidedEditBudgetFromForm";
import type { ScheduleInput } from "../components/EditScheduleModal";

type BasePayload = {
  campaign_id: string;
  adset_id: string;
};

export function buildBudgetUpdatePayload(params: {
  campaign_id: string;
  adset_id: string;
  budget: BudgetData;
}): {
  campaign_id: string;
  adset_id: string;
  budget: {
    type: "daily" | "lifetime";
    amount: { amount: number | null; currency: string };
  };
} {
  const { campaign_id, adset_id, budget } = params;
  return {
    campaign_id,
    adset_id,
    budget: wireGuidedEditBudgetFromFormDollars(budget),
  };
}

export function buildScheduleUpdatePayload(params: {
  campaign_id: string;
  adset_id: string;
  schedule: ScheduleInput;
}) {
  const { campaign_id, adset_id, schedule } = params;
  return {
    campaign_id,
    adset_id,
    schedule,
  };
}

export function buildCreativeUpdatePayload(params: BasePayload & {
  creatives: GuidedEditPayload["creatives"];
  creativeIndex: number;
  creative: GuidedEditPayload["creatives"][number];
}) {
  const { campaign_id, adset_id, creatives, creativeIndex, creative } = params;
  const nextCreatives = [...creatives];
  nextCreatives[creativeIndex] = creative;
  return {
    campaign_id,
    adset_id,
    creatives: nextCreatives,
  };
}
